import { render } from "./BlocksDemo.vue?vue&type=template&id=0551c644"
import script from "./BlocksDemo.vue?vue&type=script&lang=js"
export * from "./BlocksDemo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\prathamesh\\mahajyoti_admin_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__